export default __webpack_public_path__ + "static/media/PagerDuty.857209ec.md";